const keyList = {
  symbols: "xt.symbols", //市场列表，{version: "", symbols: []}
  currencies: "xt.currencies", //币种列表，{version: "", currencies: []}
  layout: "xt.trade.layout", //排版布局
  marketGroup: "xt.trade.marketGroup", //选择的市场分组，tabCfg, {key: "zone", plateId?: 2}
  tvChart: "xt.trade.tradingview.chart", //tradingView持久化数据
  tvOption: "xt.trade.tradingview.option", //tradingView选项 {interval: "15", chartType: 1}
  isEtfGuideKnown: "xt.trade.isEtfGuideKnown", //etf引流，存在的话不提示
  cfdStandardGuideKnown: "xt.cfd.guide.standard.v1.known", //CFD标准版新手引导，存在的话不提示
  cfdProGuideKnown: "xt.cfd.guide.pro.v1.known", //CFD专业版新手引导，存在的话不提示
  cfdTradeViewMode: "xt.cfd.trade.viewMode", // CFD 交易页 Lite/Pro：standard | pro
  symbolDepthMergePrecision: "xt.trade.symbolDepthMergePrecision", //市场深度合并精度，{"btc_usdt": "0.01"}
  orderConfirm_limit: "xt.trade.orderConfirm_limit", //下单确认，限价单，默认true
  orderConfirm_market: "xt.trade.orderConfirm_market", //下单确认，市价单，默认true
  closeConfirm_position: "xt.trade.closeConfirm_position", //平仓确认（平仓/一键平仓），默认true
  klineColorScheme: "xt.trade.klineColorScheme", //K线颜色方案，green_up=绿涨红跌，red_up=红涨绿跌
  // 因接口限流无法调试，临时存入localstorage 上线要去除
  //兼容导航市场
  market: "market", //现货市场
  leverMarket: "leverMarket", //杠杆市场
  cfdSymbols: "xt.cfdSymbols", //CFD市场列表，{version: "", symbols: []}
  registerPendingCouponGrants: "xt.register.pendingCouponGrants", // 注册送券：user-center 写入，首页弹窗后清除
  unusedCouponHomePrompt: "xt.home.unusedCouponHomePrompt", // 首页注册新人券每日弹窗：{ userId, neverShow?, lastShownDate? } 仅一条
  bindPhonePrompt: "xt.account.bindPhonePrompt", // 未绑定手机每日提醒：{ userId, lastShownAt? }
};
type Key = keyof typeof keyList;

export default {
  keyList,
  get(key: Key) {
    if (typeof window === "undefined") return;
    const itemKey = keyList[key];
    if (!itemKey) return console.log("%c$storage.get 键名不在列表内: %c" + key, "color: #ac2925", "color: red");

    const itemValue: any = localStorage.getItem(itemKey);
    let result;
    try {
      result = JSON.parse(itemValue);
    } catch (e) {
      result = itemValue;
    }
    if (result && typeof result === "object" && result["expire"]) {
      const time = result["expire"];
      if (time > Date.parse(new Date() as unknown as string)) {
        return result.value;
      }
      this.remove(key);
      return "";
    }
    return result;
  },
  /**
   * @param {Key} key
   * @param {*} value
   * @param {number} time 时间戳 过期时间 可选
   * @return {*}
   */
  set(key: Key, value: any, time?: number) {
    if (typeof window === "undefined") return;
    const itemKey = keyList[key];
    if (!itemKey) return console.log("%c$storage.set 键名不在列表内: %c" + key, "color: #ac2925", "color: red");

    try {
      if (time) {
        return localStorage.setItem(itemKey, JSON.stringify({ value, expire: time }));
      }
      localStorage.setItem(itemKey, JSON.stringify(value));
    } catch (e) {
      localStorage.setItem(itemKey, value);
    }
  }, //对象会被压成字符串
  remove(key: Key) {
    if (typeof window === "undefined") return;
    const itemKey = keyList[key];
    if (!itemKey) return console.log("%c$storage.remove 键名不在列表内: %c" + key, "color: #ac2925", "color: red");

    localStorage.removeItem(itemKey);
  },
  clear() {
    if (typeof window === "undefined") return;
    localStorage.clear();
    return true;
  },
};
